import { render, staticRenderFns } from "./NewAMForgotPwdComponent.vue?vue&type=template&id=71ad043c&scoped=true"
import script from "./NewAMForgotPwdComponent.vue?vue&type=script&lang=js"
export * from "./NewAMForgotPwdComponent.vue?vue&type=script&lang=js"
import style0 from "./NewAMForgotPwdComponent.vue?vue&type=style&index=0&id=71ad043c&prod&lang=css"
import style1 from "./NewAMForgotPwdComponent.vue?vue&type=style&index=1&id=71ad043c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ad043c",
  null
  
)

export default component.exports